/* PERFUMALINK — sitewide ambient background, reusing the exact noise/fbm +
   cream-to-taupe palette math from the locked signature-menu atmosphere
   (perfumalink-menu-atmosphere.js). That file's MenuAtmosphere class
   renders into a small square render target (sampled through blur for
   the glass panels) — wrong shape for a full-viewport background, so this
   is a separate, properly-aspect-ratio'd full-page version of the same
   shader, not a reuse of that class directly. Same "Original" palette by
   decision (2026-10-01): one shader everywhere is the real signature,
   not a per-section palette swap. */
(function () {
  function init() {
    var canvas = document.getElementById('pl-sitewide-atmosphere');
    if (!canvas) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);

    function resize() {
      canvas.width = Math.floor(window.innerWidth * dpr * 0.6);
      canvas.height = Math.floor(window.innerHeight * dpr * 0.6);
    }
    resize();
    window.addEventListener('resize', resize);

    var gl = canvas.getContext('webgl2', { antialias: false });
    if (!gl) return;

    var vertSrc = '#version 300 es\n' +
      'const vec2 verts[3] = vec2[3](vec2(-1.0,-1.0), vec2(3.0,-1.0), vec2(-1.0,3.0));\n' +
      'void main(){ gl_Position = vec4(verts[gl_VertexID], 0.0, 1.0); }';

    var fragSrc = '#version 300 es\n' +
      'precision highp float;\n' +
      'uniform vec2 u_resolution;\n' +
      'uniform float u_time;\n' +
      'out vec4 fragColor;\n' +
      'vec3 permute3(vec3 x){ return mod(((x*34.0)+1.0)*x, 289.0); }\n' +
      'float snoise(vec2 v){\n' +
      '  const vec4 C = vec4(0.211324865405187,0.366025403784439,-0.577350269189626,0.024390243902439);\n' +
      '  vec2 i = floor(v + dot(v, C.yy));\n' +
      '  vec2 x0 = v - i + dot(i, C.xx);\n' +
      '  vec2 i1 = (x0.x > x0.y) ? vec2(1.0,0.0) : vec2(0.0,1.0);\n' +
      '  vec4 x12 = x0.xyxy + C.xxzz; x12.xy -= i1;\n' +
      '  i = mod(i, 289.0);\n' +
      '  vec3 p = permute3(permute3(i.y + vec3(0.0,i1.y,1.0)) + i.x + vec3(0.0,i1.x,1.0));\n' +
      '  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);\n' +
      '  m = m*m; m = m*m;\n' +
      '  vec3 x = 2.0*fract(p*C.www) - 1.0;\n' +
      '  vec3 h = abs(x) - 0.5;\n' +
      '  vec3 ox = floor(x + 0.5);\n' +
      '  vec3 a0 = x - ox;\n' +
      '  m *= 1.79284291400159 - 0.85373472095314*(a0*a0 + h*h);\n' +
      '  vec3 g;\n' +
      '  g.x = a0.x*x0.x + h.x*x0.y;\n' +
      '  g.yz = a0.yz*x12.xz + h.yz*x12.yw;\n' +
      '  return 130.0*dot(m, g);\n' +
      '}\n' +
      'float fbm(vec2 p){\n' +
      '  float v = 0.0; float a = 0.5;\n' +
      '  for (int i = 0; i < 2; i++) { v += a*snoise(p); p *= 2.02; a *= 0.5; }\n' +
      '  return v;\n' +
      '}\n' +
      'vec3 palette(float t){\n' +
      '  vec3 ivory = vec3(0.961,0.929,0.882);\n' +
      '  vec3 cream = vec3(0.973,0.949,0.914);\n' +
      '  vec3 bone  = vec3(0.902,0.855,0.792);\n' +
      '  vec3 stone = vec3(0.831,0.776,0.718);\n' +
      '  vec3 taupe = vec3(0.675,0.608,0.541);\n' +
      '  t = clamp(t, 0.0, 1.0);\n' +
      '  vec3 c = mix(ivory, cream, smoothstep(0.0,0.3,t));\n' +
      '  c = mix(c, bone, smoothstep(0.25,0.55,t));\n' +
      '  c = mix(c, stone, smoothstep(0.5,0.8,t));\n' +
      '  c = mix(c, taupe, smoothstep(0.75,1.0,t));\n' +
      '  return c;\n' +
      '}\n' +
      'vec3 atmosphere(vec2 uv, float t){\n' +
      '  vec2 p = uv; p.x *= 1.6;\n' +
      '  vec2 warp = vec2(fbm(p*1.3 + vec2(0.0,t*0.02)), fbm(p*1.3 - vec2(t*0.015,0.0)));\n' +
      '  vec2 warped = p + warp*0.35;\n' +
      '  float density = fbm(warped*1.1 + t*0.008);\n' +
      '  float drape = fbm(vec2(warped.x*2.4, warped.y*0.6) - t*0.006);\n' +
      '  float illum = clamp(density*0.38 + drape*0.28 + 0.5, 0.0, 1.0);\n' +
      '  return palette(illum);\n' +
      '}\n' +
      'float lightShafts(vec2 uv, float t){\n' +
      '  vec2 origin = vec2(-0.2, 1.3);\n' +
      '  vec2 toPixel = uv - origin;\n' +
      '  float ang = atan(toPixel.y, toPixel.x);\n' +
      '  float pattern = sin(ang*8.0 + t*0.025)*0.5 + 0.5;\n' +
      '  pattern = pow(pattern, 5.0);\n' +
      '  float distFall = 1.0 - smoothstep(0.0, 1.5, length(toPixel));\n' +
      '  return pattern*distFall;\n' +
      '}\n' +
      'void main(){\n' +
      '  vec2 uv = gl_FragCoord.xy / u_resolution;\n' +
      '  vec3 color = atmosphere(uv, u_time);\n' +
      '  color += vec3(1.0,0.97,0.9) * lightShafts(uv, u_time) * 0.22;\n' +
      '  fragColor = vec4(color, 1.0);\n' +
      '}';

    function compile(type, src) {
      var sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) return null;
      return sh;
    }
    var vs = compile(gl.VERTEX_SHADER, vertSrc);
    var fs = compile(gl.FRAGMENT_SHADER, fragSrc);
    if (!vs || !fs) return;
    var program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;
    var vao = gl.createVertexArray();
    var uRes = gl.getUniformLocation(program, 'u_resolution');
    var uTime = gl.getUniformLocation(program, 'u_time');

    gl.useProgram(program);
    gl.bindVertexArray(vao);

    var start = performance.now();
    var paused = document.hidden;
    var raf = null;
    var last = 0;
    var cartDialog = null;
    var menuEl = null;
    /* While the bag or the menu fills the screen this canvas is completely hidden, so drawing it is wasted GPU time
       competing with the glass shaders on top. */
    function covered() {
      if (!cartDialog) cartDialog = document.querySelector('.pl-cart-dialog');
      if (!menuEl) menuEl = document.getElementById('pl-menu');
      if (cartDialog && cartDialog.hasAttribute('open') && window.innerWidth >= 900) return true;
      var s = menuEl && menuEl.dataset.state;
      return s === 'open' || s === 'opening';
    }
    function frame(now) {
      if (paused || covered()) { raf = requestAnimationFrame(frame); return; }
      /* The drift is very slow, so about 25 frames a second looks identical and costs well under half the GPU. */
      if (!reduceMotion && last && now - last < 38) { raf = requestAnimationFrame(frame); return; }
      last = now;
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.uniform1f(uTime, reduceMotion ? 0 : (now - start) * 0.001);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      if (!reduceMotion) raf = requestAnimationFrame(frame);
    }
    frame(start);

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
